module.exports = __webpack_public_path__ + "static/media/pixelperfect.4347b7bd.mp4";